import { useState, useCallback } from 'react';

export type Mode = 'browse' | 'add' | 'edit';

export function useD205Mode() {
  const [mode, setMode] = useState<Mode>('browse');

  const isEditing = mode === 'add' || mode === 'edit';

  const enterAdd = useCallback(() => setMode('add'), []);
  const enterEdit = useCallback(() => setMode('edit'), []);
  const enterBrowse = useCallback(() => setMode('browse'), []);

  return { mode, setMode, isEditing, enterAdd, enterEdit, enterBrowse };
}
